import React from 'react';
import UserRegistration from './UserRegistration';
import { AnimateLoadedContent } from '../../v2BaseComponents/Loader';
import { useUserOnboardingFlow } from './useUserOnboardingFlow';
import UserRegistrationWelcome from './UserRegistrationWelcome';
import ProfessionalNoOrganizationGate from './ProfessionalNoOrganizationGate';
import { View } from 'react-native';

export type EnforceUserOnboardingOwnProps = {
    renderApp: () => React.ReactNode;
};

export type EnforceUserOnboardingProps = EnforceUserOnboardingOwnProps;

const EnforceUserOnboarding: React.FC<EnforceUserOnboardingProps> = ({ renderApp }) => {
    const onboardingFlow = useUserOnboardingFlow();

    const renderContent = () => {
        if (onboardingFlow.fullUserOnboardingLifecycleStage === 'initializing') {
            return null;
        } else if (onboardingFlow.fullUserOnboardingLifecycleStage === 'user-registration') {
            return (
                <UserRegistration
                    isLoading={onboardingFlow.userRegistration.isLoadingUserRegistration}
                    onRegister={onboardingFlow.userRegistration.onRegisterUser}
                    defaultUserType={onboardingFlow.userRegistration.defaultUserType}
                    skipUserIntents={!!onboardingFlow.userRegistration.skipUserIntents}
                />
            );
        } else if (onboardingFlow.fullUserOnboardingLifecycleStage === 'consumer-app-welcome') {
            return (
                <UserRegistrationWelcome
                    onContinue={onboardingFlow.consumerAppWelcome.onContinue}
                    isLoading={onboardingFlow.consumerAppWelcome.isLoadingConsumerAppWelcome}
                />
            );
        } else if (onboardingFlow.fullUserOnboardingLifecycleStage === 'professional-org-selection') {
            return (
                <ProfessionalNoOrganizationGate
                    isLoading={onboardingFlow.proAppOrganizationGate.isLoadingProAppOrganizationGate}
                    onCreateOrganization={onboardingFlow.proAppOrganizationGate.onCreateOrganization}
                />
            );
        } else {
            return renderApp();
        }
    };

    const loading = onboardingFlow.fullUserOnboardingLifecycleStage === 'initializing';
    return (
        <View style={{ flex: 1 }} testID="enforce-user-onboarding">
            <AnimateLoadedContent isLoading={loading}>{renderContent}</AnimateLoadedContent>
        </View>
    );
};

export default React.memo(EnforceUserOnboarding);
